import axios from "axios";
import { ActionTypes } from "utils/constants";
import { getEnvVar } from "utils/get-env-var";

export const fetchGivingAmount = () => (
    {
        type: ActionTypes.FETCH_GIVING_AMOUNT,
        payload: axios.get(`${getEnvVar('API_BASE')}/giving-amount`)
    }
);
